import { render } from "./Wishlist.vue?vue&type=template&id=6288f78b&lang=pug"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/wishlist/wishlist/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__